import { Language, LANGUAGES, Locale } from './lingui.constants';

export const DEFAULT_CURRENCY_ISO = 'USD';

// English-market locales (full locales, not the `en` language) used to gate English-only copy.
export const ENGLISH_LOCALES: readonly Locale[] = [Locale.EnUs, Locale.EnCa, Locale.EnGb];

const LANGUAGE_SET: ReadonlySet<string> = new Set(LANGUAGES);

export const DEFAULT_LANGUAGE = Language.En;

export function isLanguage(value: string): value is Language {
  return LANGUAGE_SET.has(value);
}

// Coerce an external string to a BCP-47 language subtag ("en-US" -> "en"), or undefined if unsupported.
export function normalizeLanguage(value: string | null | undefined): Language | undefined {
  if (!value) return undefined;
  const candidate = value.replace(/_/g, '-').toLowerCase().split('-')[0];
  return isLanguage(candidate) ? candidate : undefined;
}

// Locale -> language subtag. Exhaustive Record so a new Locale must be mapped here.
export const LANGUAGE_BY_LOCALE: Record<Locale, Language> = {
  [Locale.DaDk]: Language.Da,
  [Locale.DeAt]: Language.De,
  [Locale.DeCh]: Language.De,
  [Locale.DeDe]: Language.De,
  [Locale.EnCa]: Language.En,
  [Locale.EnGb]: Language.En,
  [Locale.EnIe]: Language.En,
  [Locale.EnPseudo]: Language.En,
  [Locale.EnUs]: Language.En,
  [Locale.EsEs]: Language.Es,
  [Locale.FiFi]: Language.Fi,
  [Locale.FrCa]: Language.Fr,
  [Locale.FrFr]: Language.Fr,
  [Locale.ItIt]: Language.It,
  [Locale.NbNo]: Language.Nb,
  [Locale.NlBe]: Language.Nl,
  [Locale.NlNl]: Language.Nl,
  [Locale.PlPl]: Language.Pl,
  [Locale.SvSe]: Language.Sv,
};

export function localeToLanguage(locale: Locale): Language {
  return LANGUAGE_BY_LOCALE[locale];
}
